import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { URL, ADMIN } from "../../../../lib/lib.js";
import "./component.css";

const Component = ({componentTitle}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: '',
    image: null,
  });

  const [imagePreview, setImagePreview] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file
      }));
      const previewURL = window.URL.createObjectURL(file); // ✅ safe and correct
      setImagePreview(previewURL);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch user data if editing (for pre-filling the form)
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const response = await fetch(URL + ADMIN.category_view, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({id}),
          credentials: 'include'
        });
        const result = await response.json();
        const data = result.data;
        if (data) {
          setFormData({
            name: data.name || '',
            image: data.image || '',
          });
        }
      } catch (err) {
        console.error("Failed to fetch user details:", err);
      }
    };
  
    if (id) {
      getUserDetails();
    }
  }, [id]);


  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = new FormData();
    dataToSend.append("name", formData.name);
    if (formData.image) {
      dataToSend.append("image", formData.image);
    }
    if (id) {
      dataToSend.append("id", id);
    }
    
    try {
      const request = await fetch(URL + (id ? ADMIN.category_update : ADMIN.category_create), {
        method: "POST",
        body: dataToSend,
        credentials: "include",
      });

      if (request.status === 201 || request.status === 200) {
        let response = await request.json();
        console.log(response);
        alert(response.message);
        navigate('/admin/category');
      }
      
    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div id="adduser" className="container-fluid">
      <div className="row profile-my_flx_profile_up">
        <div className="col-xl-2 col-lg-3 col-md-2 profile-pro1 profile-admin">
          <Link to="/admin/category">
            <button className="profile-back">
              <i className="ri-arrow-left-s-line profile-lefticon"></i>
            </button>
          </Link>
        </div>
        <div className="col-xl-8 col-lg-6 col-md-8">
          <div className="profile-my_form_signup_profile">

            <form onSubmit={handleSubmit}>
              <p className="profile-login_head">{id ? "Edit" : "Create"} {componentTitle}</p>
              
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label profile-user_label">Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" placeholder="Enter Name" required />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Image</label>
                  <input type="file" accept="image/*" onChange={handleImageChange} className="form-control" required={!id} />
                </div>
              </div>

              <div className="image-preview mt-2">
                {!imagePreview && formData.image && (
                  <img src={formData.image instanceof File ? window.URL.createObjectURL(formData.image) : `${URL}/uploads/${formData.image}` }
                    alt="category"
                    style={{ maxWidth: '100px', height: 'auto', marginRight: '8px' }}
                  />
                )}
              </div>
              

              {/* Preview */}
              {imagePreview && (<img src={imagePreview} alt="Preview" className="img-thumbnail mt-2" style={{ maxWidth: '100px', height: 'auto' }} /> )}

              <button type="submit" className="profile-submit_bot1">{id ? "Update" : "Create"} {componentTitle}</button>
            </form>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-2"></div>
      </div>
    </div>
  );
};

export default Component;
